import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';

const AddNewCase = ({ closeModal, onAddNewCaseSuccess }) => {
  const { openTimeModal } = useTimeModal();

  const [status, setStatus] = React.useState('');
  const [labels, setLabels] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [phases, setPhases] = React.useState([]);
  const [selectedLabelId, setSelectedLabelId] = React.useState('');
  const [selectedCategoryId, setSelectedCategoryId] = React.useState('');
  const [selectedPhaseId, setSelectedPhaseId] = React.useState(1);

  const [number, setNumber] = React.useState('');
  const [applicant, setApplicant] = React.useState('');
  const [dateStart, setDateStart] = React.useState('');
  const [comments, setComments] = React.useState('');
  const [file, setFile] = React.useState(null);

  React.useEffect(() => {
      document.body.style.overflow = 'hidden';
  
      return () => {
          document.body.style.overflow = '';
      };
  }, []);

  const goBackToLabels = () => {
    setStatus('');
    setSelectedLabelId('');
    setContent(renderLabels(labels));
  };
  const goBackToCategories = () => {
    setStatus('');
    setSelectedCategoryId('');
    setContent(renderCategories(categories));
  };

  const loadingContent = (
    <div className={styles.liningOver} onClick={closeModal}>
      <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div style={{display: 'flex', alignItems: 'center'}}>
            <h1>Загрузка</h1>
          </div>
          <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
          </svg>
        </div>
        <div className={styles.main}>
          <Loading />
        </div>
      </div>
    </div>
  );

  const errorContent = (typeE) => (
    <div className={styles.liningOver} onClick={closeModal}>
      <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.headlineWithBackBtn}>
            <div className={styles.backBtnContainer}>
              <svg onClick={goBackToLabels} viewBox="0 0 24 24">
                <path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"></path>
              </svg>
            </div>
            <h1>Ошибка</h1>
          </div>
          <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
          </svg>
        </div>
        <div className={styles.main}>
          <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />Не удалось загрузить {typeE}. Обратитесь к администратору сети</a>
        </div>
      </div>
    </div>
  );

  const [content, setContent] = React.useState(loadingContent);

  React.useEffect(() => {
    const fetchLabels = async () => {
      try {
        const response = await axios.get('/api/labels');
        setLabels(response.data);
        setContent(renderLabels(response.data));
      } catch (error) {
        console.error("Ошибка при загрузке типов дел:", error);
        setContent(errorContent('типы дел'));
      }
    };
    fetchLabels();
  }, []);

  const renderLabels = (labels) => (
    <div className={styles.liningOver} onClick={closeModal}>
      <form className={styles.lining} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h1>Выберите тип вх. корреспонденции</h1>
          <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
          </svg>
        </div>
        <div className={styles.main}>
          {labels.map((label) => (
            <div className={styles.radioLabel} key={label.id}>
              <label htmlFor={label.id}>{label.name}</label>
              <input
                type='radio'
                className={styles.radioSelect}
                name='label'
                value={label.id}
                onChange={(e) => { setSelectedLabelId(e.target.value); setContent(loadingContent); }}
                required
              />
            </div>
          ))}
        </div>
      </form>
    </div>
  );

  React.useEffect(() => {
    const fetchCategories = async () => {
      if (selectedLabelId) {
        try {
          const response = await axios.get(`/api/categories?labelId=${selectedLabelId}`);
          setCategories(response.data);
          setContent(renderCategories(response.data));
        } catch (error) {
          console.error("Ошибка при загрузке категорий:", error);
          setContent(errorContent('категории дел', error.message));
        }
      }
    };
    fetchCategories();
  }, [selectedLabelId]);

  const renderCategories = (categories) => (
    <div className={styles.liningOver}>
      <form className={styles.lining}>
        <div className={styles.header}>
          <div className={styles.headlineWithBackBtn}>
            <div className={styles.backBtnContainer}>
              <svg onClick={goBackToLabels} viewBox="0 0 24 24">
                <path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"></path>
              </svg>
            </div>
            <h1>Выберите категорию</h1>
          </div>
          <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
          </svg>
        </div>
        <div className={styles.main}>
          {categories.map((category) => (
            <div className={styles.radioLabel} key={category.id}>
              <label htmlFor={category.id}>{category.name}</label>
              <input
                type='radio'
                className={styles.radioSelect}
                name='category'
                value={category.id}
                onChange={(e) => { setSelectedCategoryId(e.target.value); setContent(loadingContent); }}
                required
              />
            </div>
          ))}
        </div>
      </form>
    </div>
  );

  React.useEffect(() => {
    const fetchPhases = async () => {
      if (selectedCategoryId) {
        try {
          const response = await axios.get(`/api/phases?categoryId=${selectedCategoryId}`);
          setPhases(response.data);
          setContent(null);
        } catch (error) {
          console.error("Ошибка при загрузке этапов:", error);
          setContent(errorContent('этапы дел', error.message));
        }
      }
    };
    fetchPhases();
  }, [selectedCategoryId]);

  const [statusFinal, setStatusFinal] = React.useState('');
  const addNewCase = (e) => {
    e.preventDefault();

    if (selectedPhaseId && applicant && dateStart && file) {
        try {
            const formData = new FormData();
            formData.append('categoryId', parseInt(selectedCategoryId));
            formData.append('phaseId', parseInt(selectedPhaseId));
            formData.append('number', number);
            formData.append('applicant', applicant);
            formData.append('dateStart', dateStart);
            formData.append('comments', comments || 'Заметка отсутствует');
            formData.append('file', file); // Добавляем файл в запрос

            axios.post('/api/add-new-case', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            }).then(() => {
              setStatusFinal('Входящая корреспонденция успешно добавлена в систему');
              if (onAddNewCaseSuccess) {
                  onAddNewCaseSuccess(); // Уведомляем о добавлении
                  setTimeout(() => {
                    closeModal();
                  }, 1000);
              }
          }).catch(err => {
              setStatus('Ошибка при добавлении входящей корреспонденции в систему: '+err.response.data || 'Ошибка сети.');
            });
        } catch (err) {
            console.error("Ошибка при добавлении входящей корреспонденции в систему:", err);
            setStatus('Ошибка добавления входящей корреспонденции в систему: ' + err.response.data);
        }
    } else {
        setStatus('Вы не заполнили все обязательные поля');
    }
  }
  // Функция для обработки выбора файла
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };



  return (
    <>
      {content || (
        <div className={styles.liningOver}>
          <form className={styles.lining} onSubmit={addNewCase}>
            <div className={styles.header}>
              <div className={styles.headlineWithBackBtn}>
                <div className={styles.backBtnContainer}>
                  <svg onClick={goBackToCategories} viewBox="0 0 24 24">
                    <path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"></path>
                  </svg>
                </div>
                <h1>Добавьте входящую корреспонденцию в журнал</h1>
              </div>
              <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
              </svg>
            </div>
            <div className={styles.main}>
              {statusFinal ? (
                <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Готово' />{statusFinal}</a>
              ) : 
              (<>
              <a>Введите номер</a>
              <input type='text' value={number} onChange={(e) => setNumber(e.target.value)} pattern="[0-9]*" maxLength='100' placeholder='Номер вх. корреспонденции' required />
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <a>Вы можете выбрать этап, с которого начнется учёт дела в системе</a>
                <a className={styles.description}>По умолчанию будет выбран 1 этап по порядку</a>
              </div>
              {phases.map((phase) => (
                <div className={styles.radioLabel} key={phase.id}>
                  <label htmlFor={phase.id}>{phase.name}</label>
                  <input
                    type='radio'
                    className={styles.radioSelect}
                    name='phase'
                    value={phase.order_of_phase}
                    onChange={(e) => setSelectedPhaseId(e.target.value)}
                  />
                </div>
              ))}
              <a>Введите истца</a>
              <input type='text' value={applicant} onChange={(e) => setApplicant(e.target.value)} placeholder='Истец' required />
              <a>Введите дату начала отсчета</a>
              <input type='date' value={dateStart} onChange={(e) => setDateStart(e.target.value)} required />
              <a>Прикрепите файл (в формате .docx)</a>
              <div style={{border: '1px solid #e5e5e5', borderRadius: '8px', padding: '10px 20px', margin: '5px 0 10px 0'}}>
                <input type='file' placeholder='Файл' accept=".docx" onChange={handleFileChange} />
              </div>
              <a>Введите комментарий (не обязательно)</a>
              <input type='text' value={comments} onChange={(e) => setComments(e.target.value)} placeholder='Комментарий к делу' />
              {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
              <button className='button maxWidth black' type='submit'>Добавить</button>
              </>)}
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default AddNewCase;
